import React, { useCallback, useEffect, useState } from "react";
import PublicSiteAccessibilityWidget from "./PublicSiteAccessibilityWidget";
import {
  applyPublicSiteA11yToDocument,
  clearPublicSiteA11yFromDocument,
  loadPublicSiteA11yPreferences,
  savePublicSiteA11yPreferences,
  PUBLIC_SITE_A11Y_STORAGE_KEY,
} from "./publicSiteA11yPreferences";

function resolveInitialPreferences() {
  const loaded = loadPublicSiteA11yPreferences();
  if (
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
    !loaded.reduceMotion
  ) {
    return { ...loaded, reduceMotion: true };
  }
  return loaded;
}

/**
 * עטיפה לאתר הפומבי בלבד — מחיל העדפות נגישות על html בזמן mount.
 */
export default function PublicSiteAccessibilityShell({ children }) {
  const [prefs, setPrefs] = useState(resolveInitialPreferences);

  const handlePrefsChange = useCallback((next) => {
    setPrefs(next);
    savePublicSiteA11yPreferences(next);
  }, []);

  useEffect(() => {
    applyPublicSiteA11yToDocument(prefs);
    return () => clearPublicSiteA11yFromDocument();
  }, [prefs]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key !== PUBLIC_SITE_A11Y_STORAGE_KEY) return;
      setPrefs(loadPublicSiteA11yPreferences());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return (
    <>
      <PublicSiteAccessibilityWidget prefs={prefs} onPrefsChange={handlePrefsChange} />
      {children}
    </>
  );
}
